import { render, staticRenderFns } from "./AppModalHelp.vue?vue&type=template&id=7c6c0388&"
import script from "./AppModalHelp.vue?vue&type=script&lang=js&"
export * from "./AppModalHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports